import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const DASHBOARD_HOME = { ROOT_SUPER_ADMIN: "/root", SUPER_ADMIN: "/admin", PARTNER: "/partner", BUSINESS_OWNER: "/store", CUSTOMER: "/mkt/account", CREATOR: "/creator" };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = logged out
  const [impersonator, setImpersonator] = useState(() => {
    try { return JSON.parse(localStorage.getItem("zylo_impersonator")); } catch { return null; }
  });

  useEffect(() => {
    const t = localStorage.getItem("zylo_token");
    if (!t) return setUser(null);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("zylo_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("zylo_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("zylo_token");
    localStorage.removeItem("zylo_impersonator");
    setImpersonator(null);
    setUser(null);
  };

  const impersonate = (data) => {
    const backup = { token: localStorage.getItem("zylo_token"), user };
    localStorage.setItem("zylo_impersonator", JSON.stringify(backup));
    localStorage.setItem("zylo_token", data.token);
    setImpersonator(backup);
    setUser(data.user);
  };

  const exitImpersonation = () => {
    if (!impersonator) return;
    localStorage.setItem("zylo_token", impersonator.token);
    localStorage.removeItem("zylo_impersonator");
    setImpersonator(null);
    setUser(impersonator.user);
  };

  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh, impersonator, impersonate, exitImpersonation }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
